<template>

<com-item name="game.peers.plays" :size="size" :is-empty="!active" :loading="loading" title="Plays">

	<template v-slot:about>

		<p>How {{ your }} play count compares to other players.</p>

	</template>

	<template v-slot:stats>

		<core-widget :is-slim="true">

			<div class="plays-list">

				<div class="plays-list-shading">
					<div class="plays-list-shading-item" v-for="(band, index) in bands" :key="index">{{ band.to ? band.from + '-' + band.to : band.from + '+' }}</div>
				</div>

				<div class="plays-list-item" v-tooltip="tooltip(value, index)" v-for="(value, index) in playBars.values" :key="'b' + index">
					<div :style="barHeight(value)" :class="{ 'is-highlighted': playBars.self === index }"></div>
				</div>

			</div>

		</core-widget>

	</template>

</com-item>

</template>

<script>

import comItem from './../common/Item'

export default {

	props: ['fetching', 'your', 'you', 'size'],

	components: {
		'com-item': comItem
	},

	computed: {

		loading: function() { return this.fetching === 'all' },

		data: function() { return this.$store.getters['page/insights/game/peers'] },

		playBars: function() { return (this.data && this.data.playBars) ? this.data.playBars : { values: [], self: 0, min: 0, bucketWidth: 1, bandSize: 10 } },

		active: function() { return this.playBars.values && this.playBars.values.length && !this.loading },

		bandSize: function() { return this.playBars.bandSize || 10 },

		bandCount: function() {

			return Math.ceil(this.playBars.values.length / this.bandSize)

		},

		bands: function() {

			var bands = []
			var w = this.playBars.bucketWidth || 1
			var overflow = this.playBars.overflow || 0

			for (var i = 0; i < this.bandCount; i++) {

				var from = (i * this.bandSize * w) + 1
				var to = ((i + 1) * this.bandSize * w)
				var isLast = (i === this.bandCount - 1)

				if (isLast && overflow) {

					bands.push({ from: from, to: false })

				} else {

					bands.push({ from: from, to: to })

				}

			}

			return bands

		},

		max: function() {

			var m = 0
			for (var i = 0; i < this.playBars.values.length; i++) {
				if (this.playBars.values[i] > m) m = this.playBars.values[i]
			}
			return m || 1

		}

	},

	methods: {

		tooltip: function(value, index) {

			var w = this.playBars.bucketWidth || 1
			var overflow = this.playBars.overflow || 0
			var label

			if (overflow && index === this.playBars.values.length - 1) {

				label = overflow + '+ plays'

			} else {

				var from = (index * w) + 1
				var to = ((index + 1) * w)
				label = (from === to) ? from + ' plays' : from + '-' + to + ' plays'

			}

			return label + '<small>' + value + ' user' + (value === 1 ? '' : 's') + '</small>'

		},

		barHeight: function(value) {

			if (!value) return { height: '0%' }
			var pct = (100 / this.max) * value
			return { height: Math.max(8, pct) + '%' }

		}

	}

}

</script>

<style scoped>

.plays-list {
	width: 100%;
	height: 100%;
	display: flex;
	align-items: center;
}

.plays-list-shading {
	z-index: 1;
	position: absolute;
	left: 0px;
	top: 0px;
	width: 100%;
	height: 100%;
	display: flex;
}

.plays-list-shading-item {
	flex: 1 1 0;
	height: 100%;
	font-size: 16px;
	font-weight: 700;
	text-align: center;
	color: #a0c3cf;
	padding: 5px;
}

.plays-list-shading-item:nth-child(even) {
	background-color: rgba(12, 137, 178, 0.05);
}

.plays-list-item {
	height: 100%;
	padding: 25px 0px;
	flex: 1;
	display: flex;
	align-items: center;
	justify-content: center;
	cursor: pointer;
	z-index: 2;
}

.plays-list-item:hover {
	background-color: rgba(12, 137, 178, 0.1);
}

.plays-list-item div {
	width: calc(100% - 2px);
	border-radius: 4px;
	min-height: 2px;
	background-color: #4881bb;
	transition: height 100ms linear;
}

.plays-list-item div.is-highlighted {
	background-color: #3bce5a;
}

</style>
